import React from "react";
import "./Header.css";
import MainLogo from "../../images/qcr-logo2.png";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import MainNav from "../MainNav/MainNav";
import { useSelector } from "react-redux";
//import { BrowserRouter, Link } from 'react-router-dom';

export default function Header() {
  const {user} = useSelector((state) => state.auth);
  return (
    <>
      <header>
        <Navbar className="qcr-header" fixed="top" expand="lg">
          <Container fluid>
            <Navbar.Brand href="/Customer/Dashboard">
              <img src={MainLogo} alt="QCR" width={130} />
              {user.customerlogo !== "" ? (
                <>
                  <span></span>
                  <img
                    src={user.customerlogo}
                    alt="QCR"
                    width={80}
                  />{" "}
                </>
              ) : (
                ""
              )}
            </Navbar.Brand> 
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <MainNav />
          </Container>
        </Navbar>
      </header>
    </>
  );
}
